import { UploadFile } from 'fave-ui';
import {
  fetchImageAsFile,
  getFileFormat,
} from '../../../../helpers/formHelpers';
import { formatDate } from '../../../../utils/utilFunctions';
import { ProductDetails } from '../../../../services/StampCards/types';

export const appendNestedPayloadToFormData = async ({
  obj,
  formData,
  parentKey,
  excludeKeys,
}: {
  obj: Record<string, {}>;
  formData: FormData;
  parentKey: string;
  excludeKeys: string[];
}) => {
  for (const key of Object.keys(obj)) {
    if (obj.hasOwnProperty(key) && !excludeKeys.includes(key)) {
      const objectKey = obj[key as keyof typeof obj] || '';
      const isNested = key.includes('.');
      const isObject = typeof objectKey === 'object' && objectKey !== null;
      const isImage = key.includes('images');
      const isDate = key.includes('date');

      const newKey = parentKey
        ? isNested
          ? // key for nested object
            `${parentKey}${key
              .split('.')
              .map(item => `[${item}]`)
              .join('')}`
          : // key for basic object
            `${parentKey}[${isNaN(parseInt(key)) ? key : ''}]`
        : key;

      if (objectKey)
        if (isImage) {
          // image processing done here
          const images = objectKey as UploadFile[];
          images.forEach(async image => {
            formData.append(`${newKey}[]`, image as unknown as Blob);
          });
        }
        // date processing done here
        else if (isDate) {
          const parsedDate = formatDate(objectKey as Date, 'yyyy-MM-dd');
          formData.append(newKey, parsedDate);
        }
        // recursively flatten nested object
        else if (isObject)
          appendNestedPayloadToFormData({
            obj: objectKey as {},
            formData,
            parentKey: newKey,
            excludeKeys,
          });
        // straigforward values are appended to result
        else formData.append(newKey, objectKey as string);
    }
  }
  return formData;
};

export const mutateLoyaltyRewardableSettings = async (
  productDetails: ProductDetails,
) => {
  const { loyalty_rewardable_settings: loyaltyRewardableSettings } =
    productDetails;
  const parsedLoyaltyArray = [];

  for (const loyaltyObject of loyaltyRewardableSettings) {
    const { images } = loyaltyObject.rewardable_details;
    const imageObject = [];

    // image processing done here
    if (images)
      for (const image of images) {
        const imageUrl = Array.isArray(image)
          ? (image[0] as UploadFile)
          : image;

        // image data populated from api response
        if (imageUrl && imageUrl.url) {
          const fileFormat = getFileFormat(imageUrl.url);
          const fileNameArray = imageUrl.url?.split('/');
          const fileName = fileNameArray
            ? fileNameArray[fileNameArray.length - 1]
            : `image.${fileFormat}`;

          const parsedImage = await fetchImageAsFile(imageUrl.url, fileName);
          imageObject.push(parsedImage);
        }
        // new uploaded image
        else if (imageUrl && imageUrl.originFileObj) {
          const parsedImage = imageUrl.originFileObj;
          imageObject.push(parsedImage);
        }
      }

    parsedLoyaltyArray.push({
      ...loyaltyObject,
      rewardable_details: {
        ...loyaltyObject.rewardable_details,
        images: imageObject,
      },
    });
  }

  return parsedLoyaltyArray;
};
